// Brand UI font (Google Fonts via FontUtil.applyBrandFont).
// Agency/project overrides still use FontUtil.setFont.
export const brandFont = 'Sora';

export const claudeColor = '#d97757';
export const claudeInstallUrl = 'https://claude.ai/directory/more-good-reviews';
export const demoUrl = 'https://cal.com/moregoodreviews/demo';
export const docsUrl = 'https://docs.moregoodreviews.com';
export const feedbackUrl = 'https://feedback.moregoodreviews.com';

export const languages = {
    'en': 'English',
    'de': 'Deutsch',
    'es': 'Español',
    'fi': 'Suomi',
    'fr': 'Français',
    'it': 'Italiano',
    'ja': '日本語',
    'nb-NO': 'Norsk bokmål',
    'nn-NO': 'Norsk nynorsk',
    'nl': 'Nederlands',
    'pl': 'Polski',
    'pt-BR': 'Português (Brasil)',
    'pt-PT': 'Português (Portugal)',
    'sr': 'Srpski',
    'sv': 'Svenska',
    'tr': 'Türkçe',
    'uk': 'Українська',
};
